import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=045902ee&"
import script from "./ModelForm.vue?vue&type=script&lang=js&"
export * from "./ModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports